var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2216_4600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9314 4.16035C17.6946 4.36447 18.2981 4.96797 18.5022 5.73122C18.875 7.11572 18.875 10.0001 18.875 10.0001C18.875 10.0001 18.875 12.8845 18.5022 14.269C18.2981 15.0322 17.6946 15.6357 16.9314 15.8398C15.5469 16.2126 10 16.2126 10 16.2126C10 16.2126 4.45312 16.2126 3.06862 15.8398C2.30537 15.6357 1.70187 15.0322 1.49775 14.269C1.125 12.8845 1.125 10.0001 1.125 10.0001C1.125 10.0001 1.125 7.11572 1.49775 5.73122C1.70187 4.96797 2.30537 4.36447 3.06862 4.16035C4.45312 3.7876 10 3.7876 10 3.7876C10 3.7876 15.5469 3.7876 16.9314 4.16035ZM8.22501 7.33781V12.6628L12.84 10.0003L8.22501 7.33781Z",
    fill: "#171719"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2216_4600)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#C2C4C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f4f50660f9031292e9e14f8128e21fc1.svg";
export { ForwardRef as ReactComponent };